/**
 * Before/after image comparison slider.
 * Uses a native <input type="range"> (invisible, stretched over the frame)
 * as the drag surface so keyboard, touch, and mouse all work for free —
 * a CSS custom property driven by its value controls the clip-path/handle.
 */
if (!customElements.get('before-after-slider')) {
  customElements.define(
    'before-after-slider',
    class BeforeAfterSlider extends HTMLElement {
      constructor() {
        super();
        this.range = this.querySelector('.before-after__range');
        if (!this.range) return;
        this.range.addEventListener('input', this.update.bind(this));
      }

      update() {
        this.style.setProperty('--before-after-position', this.range.value + '%');
      }
    }
  );
}
